import React from 'react';

import { useDestroyModal } from 'partial/components/Modal';

import * as actions from '../actions';

function Logout() {
  const destroyModal = useDestroyModal();

  React.useEffect(() => {
    actions.logout();
    destroyModal();
  }, [destroyModal]);
  return <div>Logging out...please wait</div>;
}

Logout.propTypes = {};

export default Logout;
